module.exports = __webpack_public_path__ + "static/media/SpaceSimDemo - Made with Clipchamp.588ce818.mp4";